module.exports = __webpack_public_path__ + "img/users.d569e238.svg";